import { FC, useMemo } from 'react'
import StandingsRowWithConfig from '@sport1/news-styleguide/StandingsRowWithConfig'
import { StandingsRowProps } from '@/components/Standings/Row'
import getBaseProps from '@/components/Standings/Row/utils/getBaseProps'
import getTotalStats from '@/components/Standings/utils/getTotalStats'
import getDifferenceAsString from '@/components/Standings/utils/getDifferenceAsString'
import sportIdentifiers from '@/utils/sportIdentifiers/SportIdentifiersConfig'
import { useMobile } from '@/hooks/useMobile'

const VolleyballStandingsRow: FC<Pick<StandingsRowProps, 'competition' | 'row' | 'contextIds'>> = ({
    competition,
    row,
    contextIds,
}) => {
    const { isMobile } = useMobile()
    const baseProps = useMemo(
        () =>
            getBaseProps({
                row,
                sportIdentifier: sportIdentifiers.indoor_volleyball.name,
                isMobile,
                contextIds,
            }),
        [contextIds, isMobile, row]
    )
    if (!baseProps) {
        return null
    }

    const {
        points = 0,
        forValue = 0,
        againstValue = 0,
        played = 0,
        won = 0,
        drawn = 0,
        lost = 0,
        homeWon = 0,
        homeDrawn = 0,
        homeLoss = 0,
        awayWon = 0,
        awayDrawn = 0,
        awayLoss = 0,
    } = row

    return competition?.id &&
        ['sr:tournament:500', 'sr:tournament:501'].includes(competition.id) ? (
        <StandingsRowWithConfig
            {...baseProps}
            columns={[
                {
                    value: `${played}`,
                    width: [34, 34, 56, 64],
                },
                {
                    value: getTotalStats('S-N', won, drawn, lost),
                    width: [40, 40, 56, 64],
                },
                {
                    value: getTotalStats('S-N', homeWon, homeDrawn, homeLoss),
                    width: [0, 0, 64, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: getTotalStats('S-N', awayWon, awayDrawn, awayLoss),
                    width: [0, 0, 64, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: `${forValue}:${againstValue}`,
                    width: [40, 40, 56, 64],
                },
                {
                    value: getDifferenceAsString(forValue, againstValue),
                    width: [0, 0, 56, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: `${points}`,
                    bold: true,
                    width: [34, 34, 56, 64],
                },
            ]}
        />
    ) : (
        <StandingsRowWithConfig
            {...baseProps}
            columns={[
                {
                    value: `${played}`,
                    width: [34, 34, 56, 64],
                },
                {
                    value: getTotalStats('S-N', won, drawn, lost),
                    width: [40, 40, 56, 64],
                },
                {
                    value: `${forValue}:${againstValue}`,
                    width: [40, 40, 56, 64],
                },
                {
                    value: getDifferenceAsString(forValue, againstValue),
                    width: [0, 0, 56, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: `${points}`,
                    bold: true,
                    width: [34, 34, 56, 64],
                },
            ]}
        />
    )
}

export default VolleyballStandingsRow
